






















import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import { getMenuIconName } from '@/utils/iconHelper';

@Component({
  components: {
    Typography
  }
})
export default class FeaturesDeactivation extends Vue {
  @Prop() features!: any;

  getMenuIconName = getMenuIconName;
}
